export const messageConstants = {
    EMPTY: '',
    PROTECTED_DIALOG_TITLE: 'Access Limited',
    PROTECTED_DIALOG_CONTENT: 'Access to this course is limited to those selected. If you have received this message in error, please submit an EDU issue tracker ticket.',
    CLOSE: 'Close',
    PASSWORD_POLICY_MATCH: 'Password Matches Policy',
    PASSWORD_POLICY_MISMATCH: 'Password Does Not Match Policy',
  };
  